import { useState } from 'react'
import './VariantBuilder.css'

// colors: [{ label, hex }]
// sizes: [String]
// onChange(colors, sizes)
const VariantBuilder = ({ colors, sizes, onChange }) => {
    const [colorLabel, setColorLabel] = useState('')
    const [colorHex, setColorHex]     = useState('#000000')
    const [sizeInput, setSizeInput]   = useState('')

    const addColor = () => {
        const label = colorLabel.trim()
        if (!label) return
        if (colors.find(c => c.label.toLowerCase() === label.toLowerCase())) return
        onChange([...colors, { label, hex: colorHex }], sizes)
        setColorLabel('')
        setColorHex('#000000')
    }

    const removeColor = (label) => {
        onChange(colors.filter(c => c.label !== label), sizes)
    }

    const addSize = () => {
        const val = sizeInput.trim()
        if (!val || sizes.includes(val)) return
        onChange(colors, [...sizes, val])
        setSizeInput('')
    }

    const removeSize = (val) => {
        onChange(colors, sizes.filter(s => s !== val))
    }

    const totalVariants = Math.max(1, (colors.length || 1) * (sizes.length || 1))
    const showPreview = colors.length > 0 || sizes.length > 0

    return (
        <div className="vb-root">
            {/* ── Couleurs ── */}
            <div className="vb-section">
                <p className="vb-section-label">Couleurs</p>
                <div className="vb-chips-row">
                    {colors.map(c => (
                        <span key={c.label} className="vb-value-chip" style={{ borderLeft: `4px solid ${c.hex || '#ccc'}` }}>
                            {c.label}
                            <button onClick={() => removeColor(c.label)}>×</button>
                        </span>
                    ))}
                </div>
                <div className="vb-add-row">
                    <input
                        type="color"
                        className="vb-color-picker"
                        value={colorHex}
                        onChange={e => setColorHex(e.target.value)}
                        title="Choisir la couleur"
                    />
                    <input
                        className="vb-attr-input"
                        placeholder="Nom de la couleur (ex: Noir)"
                        value={colorLabel}
                        onChange={e => setColorLabel(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addColor())}
                    />
                    <button className="vb-btn-primary" onClick={addColor} disabled={!colorLabel.trim()}>
                        + Couleur
                    </button>
                </div>
            </div>

            {/* ── Tailles ── */}
            <div className="vb-section">
                <p className="vb-section-label">Tailles</p>
                <div className="vb-chips-row">
                    {sizes.map(s => (
                        <span key={s} className="vb-value-chip">
                            {s}
                            <button onClick={() => removeSize(s)}>×</button>
                        </span>
                    ))}
                </div>
                <div className="vb-add-row">
                    <input
                        className="vb-attr-input"
                        placeholder="Taille (ex: S, M, L, 38…)"
                        value={sizeInput}
                        onChange={e => setSizeInput(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addSize())}
                    />
                    <button className="vb-btn-primary" onClick={addSize} disabled={!sizeInput.trim()}>
                        + Taille
                    </button>
                </div>
            </div>

            {/* ── Aperçu ── */}
            {showPreview && (
                <p className="vb-preview-title">
                    → {totalVariants} variant{totalVariants > 1 ? 's' : ''} généré{totalVariants > 1 ? 's' : ''}
                    {colors.length > 0 && sizes.length > 0
                        ? ` (${colors.length} couleur${colors.length > 1 ? 's' : ''} × ${sizes.length} taille${sizes.length > 1 ? 's' : ''})`
                        : ''}
                </p>
            )}
        </div>
    )
}

export default VariantBuilder
